<template>
  <div class="share-box">
    <van-nav-bar
      title="复制链接"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="share-body">
      <template v-if="user.id">
        <div class="estimate">奖励预估收益 <span class="c-red">{{ promotion_rate }}</span> 元</div>
      </template>
      <template v-else>
        <router-link class="c-red" :to="'/login?redirect=' + $route.fullPath"
          >登录</router-link
        >后才能获取佣金
      </template>
      <textarea class="content" :value="shareText" disabled> </textarea>
    </div>

    <div class="share-footer">
      <div class="share-footer-layer">
        <van-button
          type="warning"
          round
          size="large"
          @click="copy(material.mobile_short_url)"
          >复制链接</van-button
        >
        <van-button type="warning" round size="large" @click="copy(shareText)"
          >分享素材</van-button
        >
        <van-button type="danger" round size="large" @click="go()"
          >前往购买</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      active: 1,
      material: {},
      goodInfo: {}, //商品详情
    };
  },
  created() {
     //  检测授权
    this.Post({},
      "/pdd/authorityQuery", (res) => {
      if (res.states === 1) {
const authority_query_response = res.data.authority_query_response || {}
      if(authority_query_response.bind === 1){
        this.init();
      }else if(authority_query_response.bind === 0){
        this.goAuthor();
      }
      }
    })
    //  商品详情
    this.Post({ goodSign: this.$route.query.id,searchId:this.$route.query.searchId}, "/pdd/goodsDetail", (res) => {
      if (res.states == 1) {
        let Data = res.data.goods_detail_response.goods_details[0];
        this.goodInfo = Data;
      }
    });
  },
  computed: {
    ...mapState(["rate", "user"]),
    shareText() {
      const text = `
${this.goodInfo.goods_name} \n
【到手价】: ${this.goodInfo.min_normal_price / 100}元 \n
下单链接:${this.material.mobile_short_url}
`;
      return text;
    },
    // 佣金折算
    promotion_rate() {
      return (
        ((this.goodInfo.promotion_rate / 1000) *
          (this.goodInfo.min_normal_price / 100) *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    // 前往授权
    goAuthor(){
       this.Post({},
      "/pdd/urlGenerate", (res) => {
        if(res.states === 1){
const authorLink =  res.data.rp_promotion_url_generate_response.url_list[0].mobile_url || ''
          window.location.href = authorLink
        } 
       })
    },
    init(){
      // 生成多多口令
    this.Post(
      {
        goodSign: this.$route.query.id,
        searchId: this.$route.query.searchId,
      },
      "/pdd/promotionUrlGenerate",
      (res) => {
        if (res.states === 1) {
          //           goods_promotion_url_list	OBJECT[]		多多进宝推广链接对象列表
          // mobile_short_url	STRING		唤醒拼多多app的推广短链接
          // mobile_url	STRING		唤醒拼多多app的推广长链接
          // qq_app_info	OBJECT		qq小程序信息
          // schema_url	STRING		schema的链接
          // short_url	STRING		推广短链接
          // url	STRING		推广长链接
          // weibo_app_web_view_short_url	STRING		微博推广短链接
          // weibo_app_web_view_url	STRING		微博推广链接
          // we_app_info	OBJECT		小程序信息
          // we_app_web_view_short_url	STRING		唤起微信app推广短链接
          // we_app_web_view_url	STRING		唤起微信app推广链接
          this.material =
            res.data.goods_promotion_url_generate_response.goods_promotion_url_list[0] || {}
        }
      });
    },
    go() {
      window.location.href = this.material.mobile_short_url;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/less/share.less";
</style>



// WEBPACK FOOTER //
// src/pages/pdd/share.vue